import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useParams, Link } from "react-router-dom";
import MetaData from "../layout/MetaData";
import { useGetUserDetailsQuery, useUpdateUserMutation } from "../../redux/api/userApi";
import "../../css/Admin.css";
import Loader from "../layout/Loader";
import "../../css/Driver.css";

const UserDetail = () => {
  const params = useParams();
  const [updateUser, { isLoading, error, isSuccess }] = useUpdateUserMutation();
  const { data } = useGetUserDetailsQuery(params?.id);
  const [accountStatus, setAccountStatus] = useState("Active");
  const navigate = useNavigate();

  useEffect(() => {
    if (data?.user) setAccountStatus(data?.user?.accountStatus);
  }, [data]);

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success("Driver Updated");
      navigate("/admin/drivers");
    }
  }, [error, isSuccess]);

  const submitHandler = (e) => {
    e.preventDefault();
    updateUser({ id: params?.id, body: { accountStatus } });
  };

  const user = data?.userDetail || {};
  const { _id, name, email, role, phoneNo, isVerified, vehicle, CNIC, avatar, vehicleRegistration, drivingLicense, driverVehicleNumber, driverVehicleMakeModel, driverVehicleCapacity, latitude, longitude } = user;

  if (isLoading) return <Loader />;

  const Row = ({ label, value }) => (
    <tr>
      <th scope="row">{label}</th>
      <td>{value || "—"}</td>
    </tr>
  );

  return (
    <>
      <MetaData title="User Detail" />
      <div className="row d-flex justify-content-around">
        <div className="col-12 col-lg-9 order-details">

          {role === "driver" && (
            <>
              <h3 className="mt-5 mb-3">Location Details</h3>
              <div className="card mb-4">
                <table className="table mb-0">
                  <tbody>
                    <Row label="Latitude" value={latitude || "Not Available"} />
                    <Row label="Longitude" value={longitude || "Not Available"} />
                    <tr>
                      <th scope="row">Exact Location</th>
                      <td>
                        <Link className="btn btn-primary btn-sm" to={`/admin/users/location/${_id}`} target="_blank">View on Map</Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}

          <h3 className="mb-3">User Details</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="ID" value={_id} />
                <Row label="Name" value={name} />
                <Row label="Email" value={email || "No Email"} />
                <Row label="Phone Number" value={phoneNo ? `0${phoneNo}` : "Not Available"} />
                <Row label="Role" value={role} />
                <Row label="Account Status" value={accountStatus} />
                <Row label="Is Verified" value={isVerified ? "Yes" : "No"} />
                <tr>
                  <th scope="row">WhatsApp</th>
                  <td>
                    {phoneNo ? (
                      <Link className="btn btn-success btn-sm" target="_blank" to={`https://api.whatsapp.com/send?phone=92${phoneNo}`} rel="noreferrer">
                        <i className="bi bi-whatsapp" /> Open WhatsApp
                      </Link>
                    ) : "Not Available"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {role === "driver" && (
            <>
              <h3 className="mb-3">Driver Details</h3>
              <div className="card mb-4">
                <table className="table mb-0">
                  <tbody>
                    <Row label="Vehicle" value={vehicle || "Not Specified"} />
                    <Row label="Vehicle Capacity" value={driverVehicleCapacity || "Not Added"} />
                    <Row label="Vehicle Make & Model" value={driverVehicleMakeModel || "Not Added"} />
                    <Row label="Vehicle Number" value={driverVehicleNumber || "Not Added"} />
                  </tbody>
                </table>
              </div>

              <div className="card mb-4 p-4">
                <h4 className="mb-3">Update Account Status</h4>
                <form onSubmit={submitHandler}>
                  <div className="mb-3">
                    <select className="form-select" name="accountStatus" value={accountStatus} onChange={(e) => setAccountStatus(e.target.value)}>
                      <option value="Active">Active</option>
                      <option value="Suspended">Suspended</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>
                  <button className="btn btn-primary w-100" type="submit">Update Status</button>
                </form>
              </div>

              <h3 className="mb-3">Driver Documents</h3>
              <div className="row g-3 mb-4">
                {[
                  { label: "Driver's Picture", src: avatar?.url },
                  { label: "CNIC", src: CNIC?.url },
                  { label: "Driving License", src: drivingLicense?.url },
                  { label: "Vehicle Registration", src: vehicleRegistration?.url },
                ].map((doc) => (
                  <div className="col-12 col-md-6" key={doc.label}>
                    <div className="card p-3">
                      <h6 className="mb-2 text-muted">{doc.label}</h6>
                      {doc.src && (
                        <img src={doc.src} alt={doc.label} style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px' }} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default UserDetail;